export { default as Layout } from './Layout'
import '@witbe/ui-color-palette'
import './FontAwesome'

// Added to attempt to fix flash of large Font Awesome icons on initial page load
import { config } from "@fortawesome/fontawesome-svg-core"
import "@fortawesome/fontawesome-svg-core/styles.css"
config.autoAddCss = false
